module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "warp_contrainer"
  }, [_c('div', {
    staticClass: "search_container"
  }, [_c('div', {
    staticClass: "navCalss"
  }, [_vm._v("| 预约订单")]), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('span', [_vm._v("发货单号:\n         "), _c('el-input', {
    attrs: {
      "placeholder": "输入发货单号",
      "clearable": ""
    },
    on: {
      "clear": _vm.cancelSearch
    },
    model: {
      value: (_vm.orderNo),
      callback: function($$v) {
        _vm.orderNo = $$v
      },
      expression: "orderNo"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("用户名/ViP号:\n         "), _c('el-input', {
    attrs: {
      "placeholder": "输入用户名/vip号查询",
      "clearable": ""
    },
    on: {
      "clear": _vm.cancelSearch
    },
    model: {
      value: (_vm.userName),
      callback: function($$v) {
        _vm.userName = $$v
      },
      expression: "userName"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("批次:\n\n         "), _c('el-select', {
    staticStyle: {
      "width": "255px"
    },
    attrs: {
      "remote": "",
      "remote-method": _vm.remoteMethod,
      "reserve-keyword": "",
      "filterable": "",
      "loading": _vm.loading,
      "clearable": "",
      "placeholder": "请输入批次"
    },
    on: {
      "change": _vm.batchChange,
      "clear": _vm.clearChecked
    },
    model: {
      value: (_vm.batchNum),
      callback: function($$v) {
        _vm.batchNum = $$v
      },
      expression: "batchNum"
    }
  }, _vm._l((_vm.batchList), function(item) {
    return _c('el-option', {
      key: item.sendId,
      attrs: {
        "label": item.remark,
        "value": item.remark
      }
    })
  }), 1)], 1), _vm._v(" "), _c('span', [_vm._v("货物类型:\n         "), _c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "货物类型"
    },
    on: {
      "change": function($event) {
        return _vm.init()
      },
      "clear": _vm.cancelSearch
    },
    model: {
      value: (_vm.search.goodType),
      callback: function($$v) {
        _vm.$set(_vm.search, "goodType", $$v)
      },
      expression: "search.goodType"
    }
  }, _vm._l((_vm.goodTypeSelect), function(item) {
    return _c('el-option', {
      key: item.goodType,
      attrs: {
        "label": item.goodName,
        "value": item.goodType
      }
    })
  }), 1)], 1), _vm._v(" "), _c('span', [_vm._v("签收状态：")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.getAppointList('1')
      }
    },
    model: {
      value: (_vm.checkedRecStatus),
      callback: function($$v) {
        _vm.checkedRecStatus = $$v
      },
      expression: "checkedRecStatus"
    }
  }, _vm._l((_vm.receOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('span', [_vm._v("派送点：")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "clearable": "",
      "disabled": _vm.roleId == 3
    },
    model: {
      value: (_vm.deliverAddress),
      callback: function($$v) {
        _vm.deliverAddress = $$v
      },
      expression: "deliverAddress"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "所有",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.deliverAddressArr), function(addressObj, aIndex) {
    return _c('el-option', {
      key: aIndex,
      attrs: {
        "label": addressObj.deliveryTitle,
        "value": addressObj.adminId
      }
    })
  })], 2), _vm._v(" "), _c('span', [_c('el-button', {
    staticStyle: {
      "margin-left": "12px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.getAppointList('select')
      }
    }
  }, [_vm._v("查 询")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('el-table', {
    ref: "filterTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.mainList,
      "border": "",
      "max-height": "700px"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "35",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运单",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(" " + _vm._s(scope.row.orderCount) + " 个运单 ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "realName",
      "label": "客户",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "vipCode",
      "label": "vip号",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "goodType",
      "label": "货物类型",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [(scope.row.goodType == 1) ? _c('span', {
          staticClass: "tag"
        }, [_vm._v(_vm._s(_vm.goodTypeName(scope.row.goodType)))]) : _vm._e(), _vm._v(" "), (scope.row.goodType == 2) ? _c('span', {
          staticClass: "tag tag3"
        }, [_vm._v(_vm._s(_vm.goodTypeName(scope.row.goodType)))]) : _vm._e(), _vm._v(" "), (scope.row.goodType == 3) ? _c('span', {
          staticClass: "tag tag1"
        }, [_vm._v(_vm._s(_vm.goodTypeName(scope.row.goodType)))]) : _vm._e(), _vm._v("\n               " + _vm._s(scope.row.goodName) + "\n             ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sendNo",
      "label": "发货单号",
      "width": "160px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "批次",
      "prop": "sendRemark",
      "min-width": "180px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "箱号",
      "prop": "boxNumber",
      "min-width": "180px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.sendStatus == 4) ? _c('div', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("\n               已结算\n             ")]) : (scope.row.sendStatus == 10) ? _c('div', {
          staticStyle: {
            "color": "#008b8b"
          }
        }, [_vm._v("\n               可预约\n             ")]) : (scope.row.sendStatus == 11) ? _c('div', {
          staticStyle: {
            "color": "#800080"
          }
        }, [_vm._v("\n               已预约\n             ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "amount",
      "label": "总费用",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v("\n               " + _vm._s((_vm.text =
          scope.row.sendNo == null ?
          scope.row.total :
          scope.row.amount)) + "\n             ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "7",
      "label": "预约时间",
      "align": "center",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v("\n               " + _vm._s(scope.row.appointmentTime ?
          _vm.changeDateCopy(scope.row.appointmentTime, 3) :
          "无时间数据") + "\n             ")]), _vm._v(" "), _c('el-tag', {
          staticStyle: {
            "min-width": "80px"
          },
          attrs: {
            "type": "success"
          }
        }, [_vm._v("\n               " + _vm._s(scope.row.start && scope.row.endTime ?
          _vm.itemChangedHM(scope.row.start, scope.row.endTime) :
          "无预约时间") + "\n             ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "派送点",
      "align": "center",
      "prop": "address"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "签收状态",
      "prop": "isReceipt",
      "min-width": "90px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n             " + _vm._s(scope.row.isReceipt ? "已签收" : "未签收") + "\n           ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.sendStatus == 10 || scope.row.sendStatus == 11) ? _c('el-button', {
          staticClass: "bt",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.showAccountDia(scope.row)
            }
          }
        }, [_vm._v("出库结算")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          staticClass: "bt2",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.showOrder(scope.row)
            }
          }
        }, [_vm._v("订单详情")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginations.page_sizes,
      "page-size": _vm.paginations.page_size,
      "layout": _vm.paginations.layout,
      "total": _vm.paginations.total,
      "current-page": _vm.paginations.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.mulOutStoreToPay()
      }
    }
  }, [_vm._v("批量出库结算")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "出库结算",
      "visible": _vm.accountDia,
      "width": "60%",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false
    },
    on: {
      "update:visible": function($event) {
        _vm.accountDia = $event
      }
    }
  }, _vm._l((_vm.accountList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "BigBox"
    }, [_c('div', {
      staticClass: "accountDia-content-header"
    }, [_c('div', {
      staticClass: "content-left content-left-text"
    }, [_c('div', [_vm._v("\n             发货单号:\n             "), _c('span', [_vm._v("\n               " + _vm._s(item.sendNo) + "\n             ")])]), _vm._v(" "), _c('div', [_vm._v("\n             预约状态:\n             "), _c('span', {
      staticStyle: {
        "color": "rgb(9, 157, 255)"
      }
    }, [_vm._v(" 已预约 ")])])]), _vm._v(" "), _c('div', {
      staticClass: "content-center content-left-text"
    }, [_c('div', [_vm._v("\n             VIP号:\n             "), _c('span', [_vm._v("\n               " + _vm._s(item.user.vipCode) + "\n             ")])]), _vm._v(" "), _c('div', [_vm._v("\n             入库时间:\n             "), _c('span', [_vm._v("\n               " + _vm._s(item.operatorTime ?
      _vm.changeDate(item.operatorTime, 4) :
      "无法显示") + "\n             ")])])]), _vm._v(" "), _c('div', {
      staticClass: "content-right content-left-text"
    }, [_c('div', [_vm._v("\n             客户:\n             "), _c('span', [_vm._v("\n               " + _vm._s(item.user.realName) + "\n             ")])]), _vm._v(" "), _c('div', [_vm._v("\n             订单数量: "), _c('span', [_vm._v(_vm._s(item.orderPojoList.length))])])])]), _vm._v(" "), _c('div', {
      staticClass: "accountDia-content-center1",
      staticStyle: {
        "margin-bottom": "10px"
      }
    }, [_vm._v("\n         所需总运费："), _c('span', [_vm._v(_vm._s(item.totalFreight))])]), _vm._v(" "), _c('div', {
      staticClass: "accountDia-content-center2",
      staticStyle: {
        "margin-bottom": "10px"
      }
    }, [_vm._v("\n         所需总工单费用："), _c('span', [_vm._v(_vm._s(item.totalWorkOrderFee))])]), _vm._v(" "), _c('div', {
      staticClass: "accountDia-content-center2",
      staticStyle: {
        "margin-bottom": "10px"
      }
    }, [_vm._v("\n         额外费用："), _c('span', [_vm._v(_vm._s(item.extraPrice))])]), _vm._v(" "), _c('div', {
      staticClass: "accountDia-content-footer1",
      staticStyle: {
        "width": "100%",
        "overflow": "hidden"
      }
    }, [_c('div', {
      staticClass: "content-footer-left",
      staticStyle: {
        "width": "36%",
        "float": "left",
        "margin-right": "20px"
      }
    }, [_vm._v("\n           最后总费用："), _c('span', [_vm._v(_vm._s(item.totalCost))]), _vm._v(" CAD\n         ")]), _vm._v(" "), _c('div', {
      staticClass: "content-footer-right",
      staticStyle: {
        "width": "36%",
        "float": "left"
      }
    }, [_vm._v("\n           账户余额：\n           "), _c('span', {
      staticStyle: {
        "color": "#d2691e"
      }
    }, [_vm._v(_vm._s(item.user.balance))]), _vm._v(" CAD\n         ")])]), _vm._v(" "), _c('div', {
      staticClass: "accountDia-content-footer2",
      staticStyle: {
        "width": "100%",
        "margin-top": "30px",
        "text-align": "center"
      }
    }, [_c('span', {
      staticStyle: {
        "width": "46%",
        "font-size": "17px",
        "font-weight": "bolder"
      }
    }, [_vm._v("\n           订单列表\n         ")])]), _vm._v(" "), _c('hr', {
      staticStyle: {
        "margin": "25px 0 -20px 0"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "table"
    }, [_c('el-table', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.listRow
      }
    }, [_c('el-table-column', {
      attrs: {
        "type": "index",
        "label": "#",
        "align": "center"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "productName",
        "align": "center",
        "label": "物品"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "orderNo",
        "label": "运单号",
        "align": "center"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "productNum",
        "align": "center",
        "label": "数量"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "align": "center",
        "label": "货运类型"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v("\n               " + _vm._s(_vm.goodTypeName(scope.row.goodType)) + "\n             ")]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "goodType",
        "align": "center",
        "label": "用户"
      }
    }, [_c('div', [_vm._v("\n               " + _vm._s(_vm.accountList[0].user.realName) + "\n             ")])]), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "total",
        "align": "center",
        "label": "运费（CAD）"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "demandMoney",
        "align": "center",
        "label": "工费（CAD）"
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "accountDia-footer"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.settlementBt
      }
    }, [_vm._v("确认结算")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "info"
      },
      on: {
        "click": function($event) {
          _vm.accountDia = false
        }
      }
    }, [_vm._v("取 消")])], 1)])
  }), 0), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.listDia,
      "width": "70%",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.listDia = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('span', {
          staticClass: "warningDia-footer"
        }, [_c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.listDia = false
            }
          }
        }, [_vm._v("确 定")])], 1)]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "diaText"
  }, [_c('div', {
    staticClass: "e_text"
  }, [_vm._v("发货单号：" + _vm._s(_vm.orderMsg.sendNo))]), _vm._v(" "), _c('div', {
    staticClass: "e_text"
  }, [_vm._v("订单数量：" + _vm._s(_vm.orderMsg.orderCount))]), _vm._v(" "), _c('div', {
    staticClass: "e_text"
  }, [_vm._v("相关用户VIP：" + _vm._s(_vm.user.vipCode))])]), _vm._v(" "), _c('div', [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.orderList,
      "max-height": "300px"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "名称",
      "align": "center",
      "width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "货物类型",
      "width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n             " + _vm._s(_vm.goodTypeName(scope.row.goodType)) + "\n           ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户",
      "align": "center",
      "width": "120"
    }
  }, [_vm._v("\n           " + _vm._s(_vm.user.realName) + "\n         ")]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "vip号",
      "align": "center",
      "width": "120"
    }
  }, [_vm._v("\n           " + _vm._s(_vm.user.vipCode) + "\n         ")]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "expressNo",
      "label": "运单号",
      "align": "center",
      "width": "170"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "predictTotal",
      "label": "商品价格",
      "align": "center",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center",
      "width": "120"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "rgb(9, 157, 255)"
    }
  }, [_vm._v(" 已预约 ")])]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "派送点",
      "align": "center",
      "width": "180"
    }
  }, [_vm._v("\n           " + _vm._s(_vm.user.deliveryTitle) + "\n         ")]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total",
      "label": "运费(CAD)",
      "align": "center",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "date",
      "label": "下单时间",
      "align": "center",
      "width": "240px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n             " + _vm._s(_vm.changeDate(scope.row.storeTime, 4)) + "\n           ")]
      }
    }])
  })], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-be06e6b8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/delivery/book.vue
// module id = 1261
// module chunks = 2